import React from 'react';
import Moment from 'moment';
import {
  Box as BoxBase,
  styled,
  MenuItem as MenuItemBase,
} from '@mui/material';
import { withShowable } from '../../../_global/lib/withShowable';
import {
  downloadQuoteDocuments,
  downloadQuoteProposal,
} from '../../../../inbox/QuotesService';
import { downloadAWSDoc } from '../../../../accounts/AccountService';
import { saveBlobFile } from '../../../../utils/appUtils';
import PolicyHolderQuotePolicySummary from '../../../quotes-policies/drawers/PolicyHolderQuotePolicySummary';
import {
  MenuTriggerButton,
  SimpleMenu,
} from '../../../../components/Menus/SimpleMenu';
import useNotifications from '../../../../_lib/notifications/useNotifications';

const MenuItem = withShowable(MenuItemBase);
const FlexBox = withShowable(
  styled(BoxBase)(() => ({
    display: 'flex',
  }))
);

export default function PolicyHolderQuoteSummary({ quote }: any) {
  return (
    <PolicyHolderQuotePolicySummary {...quote}>
      <FlexBox
        alignItems="center"
        width="15%"
        height="inherit"
        justifyContent="flex-end"
        pr={1}
        show
      >
        <PolicyHolderQuoteActionMenu quote={quote} />
      </FlexBox>
    </PolicyHolderQuotePolicySummary>
  );
}

const PolicyHolderQuoteActionMenu = ({ quote }: any) => {
  const { handleDownloadApplication, handleDownloadProposal } =
    useQuoteDownloadOptions(quote);

  const menuOrigin = {
    vertical: 'top',
    horizontal: 'right',
  };

  return (
    <SimpleMenu
      id="policyholder-policy-summary-options"
      anchor={<MenuTriggerButton />}
      // @ts-expect-error TS(2322): Type '{ vertical: string; horizontal: string; }' i... Remove this comment to see the full error message
      anchorOrigin={menuOrigin}
      // @ts-expect-error TS(2322): Type '{ vertical: string; horizontal: string; }' i... Remove this comment to see the full error message
      transformOrigin={menuOrigin}
    >
      <MenuItem
        show={Boolean(quote.isApplicationAvailable)}
        onClick={handleDownloadApplication}
      >
        Download Application
      </MenuItem>

      <MenuItem show={!quote.isEndorsement} onClick={handleDownloadProposal}>
        Download Quote
      </MenuItem>
    </SimpleMenu>
  );
};

const useQuoteDownloadOptions = (quote: any) => {
  const notifications = useNotifications();

  const handleDownloadProposal = () => {
    const { id: quoteId, accountId, quoteNumber, created } = quote;

    downloadQuoteProposal(accountId, quoteId, Moment(created).unix())
      .then(({ data: url }) =>
        downloadAWSDoc(url)
          .then((response) =>
            saveBlobFile(response, `${quoteNumber}-Cowbell-Proposal`, '.pdf')
          )
          .catch(() =>
            notifications.error('Unable to download the quote proposal')
          )
      )
      .catch(() =>
        notifications.error('Unable to download the quote proposal')
      );
  };

  const handleDownloadApplication = () => {
    const {
      id: quoteId,
      accountId,
      isEndorsement,
      policyNumber,
      created,
      product,
      quoteNumber,
    } = quote;

    downloadQuoteDocuments(
      accountId,
      quoteId,
      Moment(created).unix(),
      isEndorsement,
      product,
      quoteNumber
    )
      .then((response) => downloadAWSDoc(response.data))
      .then((response) =>
        saveBlobFile(response, `${policyNumber}-Cowbell-Application`, '.pdf')
      )
      .catch(() => notifications.error('Unable to download the Application'));
  };

  return { handleDownloadProposal, handleDownloadApplication };
};
